module.exports = __webpack_public_path__ + "static/media/user-music.7a92315d.svg";